import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
var zIndexStyles = css(["", ";"], function (_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
  return "z-index: ".concat(isOpen ? '11' : '10');
});
var simpleStyles = css(["align-content:center;> div:first-child{", " border-radius:8px;border:0px;padding:4px 12px;font-weight:400;min-width:120px;box-shadow:none;background:", ";color:", ";}"], getFont(0), function (_ref2) {
  var theme = _ref2.theme;
  return theme.plus.grey;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.plus.fontDD;
});
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-18bgotw-0"
})(["display:", ";width:auto;cursor:pointer;", " ", " ", " ", ""], function (_ref4) {
  var display = _ref4.display;
  return display;
}, function (_ref5) {
  var withZIndex = _ref5.withZIndex;
  return withZIndex ? zIndexStyles : 'position: relative;';
}, function (_ref6) {
  var withPadding = _ref6.withPadding;
  return withPadding ? "height: 42px;" : '';
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    "])), function (_ref7) {
  var withBorder = _ref7.withBorder;
  return withBorder ? 'min-width: 180px;' : '';
}), function (_ref8) {
  var variant = _ref8.variant;
  return variant === 'simple' && simpleStyles;
});